import { commitMutation, graphql } from "react-relay";
import environment from "../AuthEnv";
import { GC_AUTH_TOKEN, GC_USER_ID, GRAPHQL_PATH } from "../constants";
import { ConnectionHandler } from "relay-runtime";

const mutation = graphql`
	mutation SimpleAddNoteMutation($input: AddNoteInput!) {
		addNote(input: $input) {
			noteEdge {
				cursor
				node {
					id
					note
					date_saved
					isNote
				}
			}
		}
	}
`;

export default (postId, note, callback) => {
	const variables = {
		input: {
			postId: postId,
			note: note
		}
	};

	commitMutation(environment, {
		mutation,
		// optimisticResponse,
		variables,

		onCompleted: (response, errors) => {
			if (response.addNote != null) {
				callback();
			} else {
				console.log("Unable to create new Note!");
			}
		},
		onError: err => console.error(err)
	});
};
